export default function(text) {
  const node = document.createElement('textarea');
  node.value = text;

  document.body.appendChild(node);
  node.select();
  document.execCommand('copy');
  document.body.removeChild(node);
}
